import parse from "date-fns/parse";
import format from "date-fns/format" ;

export const hookFormDate = ( value, format ) =>
{
    return value === null || value === undefined ? null : parse(value, format, new Date())
}

export const hookIntToBool = ( value, format ) =>
{
    return value === null || value === undefined ? false : +(value) === 1
}

export const hookFormDropdownValue = ( value ) =>
{
    if ( value === null || value === undefined )
    {
        return null ;
    }
    else
    {
        const v = { value: +(value) } ;

        return v ;
    }
    // return value === null || value === undefined ? null : { value: +(value) }
}

export const parseFormDate = ( value, dateFormat ) =>
{
    return value === null || value === '' ? null : format( value, dateFormat) ;
}